import get from "lodash/get";

export const hasStsPingError = state => get(state, "stsPing.hasError");
